import { action, computed, makeObservable, observable } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';

export default class ErrorMessageModalDelegate extends ModalDelegate {
  private _errorMessage: string = '';

  get errorMessage(): string {
    return this._errorMessage;
  }

  setMessageAndShowModal(message: string): void {
    this._errorMessage = message;
    this.open();
  }

  constructor() {
    super();
    makeObservable<ErrorMessageModalDelegate, '_errorMessage'>(this, {
      _errorMessage: observable,
      errorMessage: computed,
      setMessageAndShowModal: action.bound,
    });
  }
}
